import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class GroupWithExclusionIcon extends BaseIcon {

  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()
    return [
      <path d="M14 15h-3v-1h3v-3h1v4h-1zm0-12h-3V2h4v4h-1V3zM6 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM3 6H2V2h4v1H3v3zm0 8h3v1H2v-4h1v3zM9.5 4c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zm0 3c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zm3-3c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zm0 3c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zM11 5c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z" fillRule="evenodd" clipRule="evenodd" fill={color}/>
    ]
  }
  getViewBox = () => '0 0 16 16'
}
